var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M2 5h20v14H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.335 13.077l-1.107.57.212-1.208-.895-.855 1.238-.178.552-1.097.552 1.098 1.239.178-.896.853.212 1.207",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.048 15.268c1.84 0 3.333-1.463 3.333-3.267 0-1.804-1.492-3.267-3.333-3.267-1.841 0-3.334 1.463-3.334 3.267 0 1.804 1.493 3.267 3.334 3.267zm.952-.934c1.314 0 2.381-1.045 2.381-2.333 0-1.288-1.067-2.333-2.38-2.333-1.315 0-2.382 1.045-2.382 2.333 0 1.288 1.067 2.333 2.381 2.333z",
    fill: "#fff"
  })));
}
export default SvgTr;